package com.cybersoftsolution.cybersoftsolutionweb.components.icons

import androidx.compose.runtime.Composable
import com.cybersoftsolution.cybersoftsolutionweb.components.sidePanels.unselectedColor
import com.cybersoftsolution.cybersoftsolutionweb.utils.Resources
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.GeneralKind
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div

@Composable
fun MyFaIcon(
    style: CssStyle<GeneralKind>? = null,
    modifier: Modifier = Modifier,
    id: String?=null,
    enabled: Boolean = true,
    faIconsClassName: Resources.FaIconsClassName,
    onClick: () -> Unit = {},
    size: Int? = null,
    color: CSSColorValue = unselectedColor,

    ) {

    val styleModifier = style?.toModifier() ?: Modifier


//    Column (
//        verticalArrangement = Arrangement.Center,
//        horizontalAlignment = Alignment.CenterHorizontally,
//        modifier = Modifier
//            .then(modifier)
//            .color(color)
//            .onClick { onClick() }
//            .cursor(Cursor.Pointer)
//    ){
        Div  (
            attrs = styleModifier
                .thenIf(
                    condition = id != null,
                    other = Modifier.id(id.orEmpty())
                )

//                .color(color)
                .classNames(faIconsClassName.className,faIconsClassName.icon)
                .thenIf(
                    condition = size != null,
                    other = Modifier
                        .styleModifier {
                            fontSize(size!!.px)
//                            color(color)
                        }
                )
                .onClick { onClick() }
                .cursor(Cursor.Pointer)
                .then(modifier)
                .toAttrs()
        )


//    }





}



